import { useState } from 'react'
import Navigation from '../components/Navigation/Navigation'
import FileItem from '../components/FileItem/FileItem'
import Sidebar from '../components/Sidebar/Sidebar'
import { mockFiles } from '../data/mockData'
import layoutStyles from '../styles/layout.module.css'
import cardStyles from '../styles/card.module.css'
import fileItemStyles from '../components/FileItem/FileItem.module.css'

export default function SearchPage() {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState(mockFiles)

  const handleSearch = (query: string) => {
    setSearchQuery(query)
    if (!query.trim()) {
      setSearchResults(mockFiles)
      return
    }
    
    const filtered = mockFiles.filter(file => 
      file.name.toLowerCase().includes(query.toLowerCase())
    )
    setSearchResults(filtered)
  }

  return (
    <div className={layoutStyles.mainLayout}>
      <Sidebar activeItem="search" />
      
      <div className={layoutStyles.mainContentWrapper}>
        <Navigation />
        <main className={layoutStyles.mainContent}>
          <div className={layoutStyles.container}>
            <div className={cardStyles.card}>
              <div className={cardStyles.cardHeader}>
                <h1 className={cardStyles.cardTitle}>Search Files</h1>
              </div>
              
              <div style={{ marginBottom: '2rem' }}>
                <input
                  type="text"
                  placeholder="Search your files..."
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '0.75rem 1rem',
                    border: '1px solid var(--border-color)',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                />
              </div>
              
              <div className={fileItemStyles.fileList}>
                {searchResults.length > 0 ? (
                  searchResults.map(file => (
                    <FileItem
                      key={file.id}
                      name={file.name}
                      type={file.type}
                      size={file.size}
                      uploadedAt={file.uploadedAt}
                      source={file.source}
                    />
                  ))
                ) : (
                  <div style={{ 
                    textAlign: 'center', 
                    padding: '3rem',
                    color: 'var(--text-secondary)'
                  }}>
                    No files found matching "{searchQuery}"
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}